import React from 'react';
import { StylovyzeComposableDialog } from '@innovyze/stylovyze';

interface Props {
	title: string;
	children: React.ReactNode;
	footerContent: React.ReactNode;
	modalOpen: boolean;
	closeModal: () => void;
	goToSensorEdit?: () => void;
}

export default function EditSensorDataDialog({
	title,
	footerContent,
	children,
	modalOpen,
	closeModal,
}: Props): React.ReactElement {
	return (
		<StylovyzeComposableDialog
			title={title}
			open={modalOpen}
			footerProps={{ horizontalAlignment: 'space-between' }}
			footer={footerContent}
			onCancel={() => {
				closeModal();
			}}>
			{children}
		</StylovyzeComposableDialog>
	);
}
